module.exports = __webpack_public_path__ + "static/img/cpfw-ptzs1.b1f45fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cpfw-ptzs1.png
// module id = +q1k
// module chunks = 0